export class CustomerPaymentMethodsException extends Error {
}
